import { RimbuError } from '@rimbu/base';
import { TraverseState } from '@rimbu/common';
import { Stream } from '@rimbu/stream';
export class OrderedSetBuilder {
    constructor(context, source) {
        this.context = context;
        this.source = source;
        this._lock = 0;
        // prettier-ignore
        this.has = (value) => {
            return this.source?.has(value) ?? this.setBuilder.has(value);
        };
        this.add = (value) => {
            this.checkLock();
            const changed = this.setBuilder.add(value);
            if (changed) {
                this.source = undefined;
                this.orderBuilder.append(value);
            }
            return changed;
        };
        this.addAll = (source) => {
            this.checkLock();
            return Stream.from(source).filterPure({ pred: this.add }).count() > 0;
        };
        // prettier-ignore
        this.remove = (value) => {
            this.checkLock();
            if (!this.context.setContext.isValidValue(value))
                return false;
            const changed = this.setBuilder.remove(value);
            if (changed) {
                this.source = undefined;
                let index = -1;
                this.orderBuilder.forEach((v, i, halt) => {
                    if (Object.is(v, value)) {
                        index = i;
                        halt();
                    }
                });
                this.orderBuilder.remove(index);
            }
            return changed;
        };
        // prettier-ignore
        this.removeAll = (values) => {
            this.checkLock();
            return Stream.from(values).filterPure({ pred: this.remove }).count() > 0;
        };
        this.forEach = (f, options = {}) => {
            const { reversed = false, state = TraverseState() } = options;
            if (state.halted)
                return;
            this._lock++;
            if (undefined !== this.source) {
                this.source.order.forEach(f, { reversed, state });
            }
            else {
                this.orderBuilder.forEach(f, { reversed, state });
            }
            this._lock--;
        };
        this.build = () => {
            if (undefined !== this.source)
                return this.source;
            if (this.size === 0)
                return this.context.empty();
            const order = this.orderBuilder.build().assumeNonEmpty();
            const sourceMap = this.setBuilder.build().assumeNonEmpty();
            return this.context.createNonEmpty(order, sourceMap);
        };
    }
    checkLock() {
        if (this._lock)
            RimbuError.throwModifiedBuilderWhileLoopingOverItError();
    }
    prepareMutate() {
        if (undefined === this._orderBuilder || undefined === this._setBuilder) {
            if (undefined !== this.source) {
                this._orderBuilder = this.source.order.toBuilder();
                this._setBuilder = this.source.sourceSet.toBuilder();
            }
            else {
                this._orderBuilder = this.context.listContext.builder();
                this._setBuilder = this.context.setContext.builder();
            }
        }
    }
    get orderBuilder() {
        this.prepareMutate();
        return this._orderBuilder;
    }
    get setBuilder() {
        this.prepareMutate();
        return this._setBuilder;
    }
    get size() {
        return this.source?.size ?? this.orderBuilder.length;
    }
    get isEmpty() {
        return this.size === 0;
    }
}
//# sourceMappingURL=builder.mjs.map